// Cryptographically strong replacements for Math.random(), used wherever a
// generated value is submitted as a payment/transaction reference and needs
// real unpredictability rather than just uniqueness.

const DEFAULT_ALPHABET =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

export function randomAlphaNumeric(length, alphabet = DEFAULT_ALPHABET) {
  const bytes = new Uint32Array(length);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < length; i++) out += alphabet[bytes[i] % alphabet.length];
  return out;
}

// Inclusive of both min and max.
export function randomInt(min, max) {
  const bytes = new Uint32Array(1);
  crypto.getRandomValues(bytes);
  return min + (bytes[0] % (max - min + 1));
}
